import { j as e, c as p } from "../../utils-BdNIfrGQ.js";
import { D as n } from "../../Div-spVpsZsH.js";
import "../../Div.skeleton-DLnqOZrU.js";
import "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import "react";
import { c as i } from "../../index-Di82Y7n3.js";
const c = i(
  "absolute bottom-0 left-0 top-0 bg-proportion-bar-on-course"
), d = i(
  "absolute inset-0 bg-proportion-bar-on-course-stripe"
), l = i(
  "absolute bottom-0 top-0 bg-proportion-bar-finished"
), a = (o) => Math.max(0, Math.min(100, o)), m = (o) => {
  const r = a(o.onCourse * 100), t = a(Math.min(o.finished * 100, 100 - r));
  return { onCoursePercent: r, finishedPercent: t };
}, u = ({ className: o, segments: r }) => {
  const { finishedPercent: t, onCoursePercent: s } = m(r);
  return /* @__PURE__ */ e.jsxs(
    n,
    {
      "aria-hidden": !0,
      className: p("relative h-7 w-full overflow-hidden rounded-full bg-border", o),
      "data-testid": "proportion-bar",
      children: [
        s > 0 ? /* @__PURE__ */ e.jsx(
          n,
          {
            className: c(),
            "data-testid": "proportion-bar-on-course",
            style: { width: `${s}%` },
            children: /* @__PURE__ */ e.jsx(n, { className: d() })
          }
        ) : null,
        t > 0 ? /* @__PURE__ */ e.jsx(
          n,
          {
            className: l(),
            "data-testid": "proportion-bar-finished",
            style: {
              left: `${s}%`,
              width: `${t}%`
            }
          }
        ) : null
      ]
    }
  );
};
u.displayName = "Proportion bar";
export {
  u as default,
  m as proportionBarSegmentWidths
};
